import { Moon, Sun } from "lucide-react";
import { useTheme } from "next-themes";
import { cn } from "@/lib/utils";

export const ThemeToggle = ({ compact = false, className }) => {
  const { resolvedTheme, setTheme } = useTheme();
  const isDark = resolvedTheme === "dark";
  return (
    <button
      type="button"
      data-testid="theme-toggle-button"
      onClick={() => setTheme(isDark ? "light" : "dark")}
      aria-label={isDark ? "Passa alla modalità chiara" : "Passa alla modalità scura"}
      className={cn(
        "inline-flex items-center gap-2 rounded-xl px-3 h-10 text-sm text-muted-foreground hover:text-foreground hover:bg-accent transition-colors",
        className,
      )}
    >
      {isDark ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
      {!compact && <span>{isDark ? "Modalità chiara" : "Modalità scura"}</span>}
    </button>
  );
};
